import { CepInput, TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const EnderecoVisualizar = ({ endereco = {} }) => {
  const { pais, cep, logradouro, numero, complemento, uf, cidade, bairro, referencia } = endereco;

  return (
    <>
      {pais?.id && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel label="País" id="endereco.pais" value={pais.nome} />
        </Grid>
      )}
      <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
        <TextLabel label="CEP" id="endereco.cep" value={cep} InputProps={{ inputComponent: CepInput }} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextLabel label="Logradouro" id="endereco.logradouro" value={logradouro} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextLabel label="Número" id="endereco.numero" value={numero} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextLabel label="Complemento" id="endereco.complemento" value={complemento} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextLabel label="UF" id="endereco.uf" value={uf && uf.sigla} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextLabel label="Cidade" id="endereco.cidade" value={cidade && cidade.nome} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextLabel label="Bairro" id="endereco.bairro" value={bairro} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextLabel label="Referência" id="endereco.referencia" value={referencia} />
      </Grid>
    </>
  );
};

EnderecoVisualizar.propTypes = {
  endereco: PropTypes.shape({
    cep: PropTypes.string,
    logradouro: PropTypes.string,
    numero: PropTypes.string,
    complemento: PropTypes.string,
    uf: PropTypes.shape({
      id: PropTypes.string,
      sigla: PropTypes.string,
      nome: PropTypes.string,
    }),
    cidade: PropTypes.shape({
      id: PropTypes.string,
      nome: PropTypes.string,
    }),
    bairro: PropTypes.string,
    referencia: PropTypes.string,
  }),
};

export default EnderecoVisualizar;
